export default {
  "items": [
    {
      "title": "Classtop",
      "path": "/",
      "component": "ChangeSchool/index.js",
    }, 
    {
      "title": "Student",
      "path": "/student",
      "component": "Student/index.js",
      "permissionRequired": ["student_channel"],
    }, 
    {
      "title": "Student Settings",
      "path": "/student-settings",
      "permissionRequired": ["edit_school_setting"],
      "component": "StudentSettings/index.js"
    },
    {
      "title": "Class",
      "path": "/class",
      "permissionRequired": ["class_channel"],
      "component": "Class/index.js"
    },
    {
      "title": "Class",
      "path": "/class/:classState",
      "permissionRequired": ["class_channel"],
      "component": "Class/index.js"
    },
    {
      "title": "One to One",
      "path": "/one_one",
      "permissionRequired": ["private_class_channel"],
      "component": "ClassOne/index.js"
    },
    {
      "title": "One to One",
      "path": "/one_one/:classState",
      "permissionRequired": ["private_class_channel"],
      "component": "ClassOne/index.js"
    },
    {
      "title": "Teacher",
      "path": "/teacher",
      "permissionRequired": ["teacher_channel"],
      "component": "Teacher/index.js"
    },
    {
      "title": "Attendance",
      "path": "/teacher/attendance/:teacherId",
      "permissionRequired": ["teacher_channel", "read_teacher_check_in_record"],
      "component": "Teacher/Attendance/index.js"
    },
    {
      "title": "Class Details",
      "path": "/class-detail/:classId",
      "permissionRequired": ["class_channel", "read_class_detail"],
      "component": "ClassDetail/index.js"
    },
    {
      "title": "Class One Details",
      "path": "/class-one-detail/:classId",
      "permissionRequired": ["private_class_channel", "read_private_class_detail"],
      "component": "ClassOneDetail/index.js"
    },
    {
      "title": "Classroom",
      "path": "/classroom",
      "permissionRequired": ["classroom_channel"],
      "component": "Classroom/index.js"
    },
    {
      "title": "Finance",
      "path": "/finance",
      "permissionRequired": ["finance_channel"],
      "component": "Finance/index.js"
    },
    {
      "title": "Monthly Finance",
      "path": "/monthly-finance",
      "permissionRequired": ["finance_channel"],
      "component": "MonthlyFinance/index.js"
    },
    {
      "title": "School Settings",
      "path": "/school-settings",
      "permissionRequired": ["school_setting_channel"],
      "component": "SchoolSettings/index.js"
    },
    {
      "title": "School Information",
      "path": "/school-information",
      "permissionRequired": ["school_setting_channel", "edit_school_setting"],
      "component": "SchoolInformation/index.js"
    },
    {
      "title": "Website",
      "path": "/website",
      "permissionRequired": ["website"],
      "notForBasicUser": true, // to check if the user is on basic plan or free trial, restrict the route when true
      "component": "Website/index.js"
    },
    {
      "title": "Schedule",
      "path": "/schedule",
      "permissionRequired": ["timetable_channel"],
      "component": "Schedule/index.js"
    },
    {
      "title": "Print Schedule",
      "path": "/print-schedule",
      "permissionRequired": ["timetable_channel"],
      "component": "PrintSchedule/index.js"
    },
    {
      "title": "Announcement",
      "path": "/announcement",
      "permissionRequired": ["announcement_channel"],
      "component": "Announcement/index.js"
    },
    {
      "title": "Activity Log",
      "path": "/logs",
      "permissionRequired": ["operation_log_channel"],
      "notForBasicUser": true,
      "component": "Logs/index.js"
    },
    {
      "title": "Dashboard",
      "path": "/dashboard",
      "component": "Dashboard/index.js"
    },
    {
      "title": "Privacy EN",
      "path": "/privacy-en",
      "component": "PrivacyPolicy/en.js"
    },
    {
      "title": "Privacy CN",
      "path": "/privacy-cn",
      "component": "PrivacyPolicy/cn.js"
    },
    {
      "title": "Poster",
      "path": "/poster",
      "permissionRequired": ["poster_channel"],
      "notForBasicUser": true,
      "component": "Poster/index.js"
    },
    {
      "title": "Poster",
      "path": "/edit-poster/:posterId",
      "permissionRequired": ["poster_channel"],
      "notForBasicUser": true,
      "component": "Poster/EditPoster/index.js"
    },
    {
      "title": "Poster Preview",
      "path": "/poster-preview/:posterId",
      "permissionRequired": ["poster_channel"],
      "notForBasicUser": true,
      "component": "Poster/SaasPosterPreview/index.js"
    },
    {
      "title": "Registration Table",
      "path": "/registration-table/:posterId",
      "permissionRequired": ["poster_channel"],
      "notForBasicUser": true,
      "component": "Poster/RegistrationTable/index.js"
    },
    {
      "title": "Total Registration Table",
      "path": "/registration-table/",
      "permissionRequired": ["poster_channel"],
      "notForBasicUser": true,
      "component": "Poster/RegistrationTable/index.js"
    },
    {
      "title": 'Contacts',
      "path": '/contacts',
      "component": 'PotentialClient/index.js',
      "notForBasicUser": true,
      "permissionRequired": ["contact_channel"],
    },
    {
      "title": 'Contacts',
      "path": '/contact-settings',
      "component": 'PotentialClientSettings/index.js',
      "notForBasicUser": true,
      "permissionRequired": ["contact_channel"],
    },
    {
      "title": 'Import Student',
      "path": '/import-student',
      "component": 'ImportStudent/index.js',
      "permissionRequired": ["create_student", "edit_school_setting"],
    },
    {
      "title": "UI Library",
      "path": "/ui-library",
      "component": "UILibrary/index.js"
    },
    {
      "title": "Account Settings",
      "path": "/account-settings",
      "component": "AccountSettings/index.js"
    },
    {
      "title": "No Permission",
      "path": "/no-permission",
      "component": "NoPermission/index.js"
    },
    {
      "title": "Registration Terms and Conditions",
      "path": "/registration-agreement",
      "component": "RegistrationAgreement/index.js",
      "permissionRequired": ["edit_school_setting"],    
    },
    {
      "title": "Waiting List",
      "path": "/waiting-list",
      "component": "WaitingList/index.js",
      // "permissionRequired": ["edit_school_setting"],    
    },
    {
      "title": "Teacher Career",
      "path": "/teacher-career",
      "component": "TeacherCareer/index.js",
      // "permissionRequired": ["edit_school_setting"],    
    },
    {
      "title": "Payment Information",
      "path": "/custom-payment-info",
      "component": "PaymentInformation/index.js",
      // "permissionRequired": ["edit_school_setting"],    
    },
	]
}



// WEBPACK FOOTER //
// ./src/routes/routes.js